import BaseMappingsModel from './baseMappingsModel';

// Remove empty strings from address object
const cleanAddress = (address) => {
  if (!address || typeof address !== 'object') return address;
  const cleaned = { ...address };
  Object.keys(cleaned).forEach(key => {
    if (cleaned[key] === '') {
      delete cleaned[key];
    }
  });
  return cleaned;
};

const MAPPINGS = {
  additional_loading_addresses: 'additional_loading_addresses',
  additional_unloading_addresses: 'additional_unloading_addresses',
  adr_captions_ids: 'adr_captions_ids',
  adr: 'adr',
  air_passage: 'air_passage',
  bank_days: 'bank_days',
  belts: 'belts',
  bodytype: 'bodytype',
  car_count: 'car_count',
  cargo_designation: 'cargo_designation',
  cargo_designations_additional: 'cargo_designations_additional',
  cargo_designations_id: 'cargo_designations_id',
  cmr: 'cmr',
  company_logo_url_small: 'company_logo_url_small',
  conics: 'conics',
  contact_phone: 'contact_phone',
  count: 'count',
  creation_date: 'creation_date',
  currency_id: 'currency_id',
  diameter: 'diameter',
  direct_contract: 'direct_contract',
  documents: 'documents',
  employee_ids: 'employee_ids',
  firstname: 'firstname',
  fuel_prepayment: 'fuel_prepayment',
  gps_tracking: 'gps_tracking',
  height: 'height',
  hitch: 'hitch',
  id: 'id',
  is_other: 'is_other',
  lastname: 'lastname',
  legal_address: 'legal_address',
  length: 'length',
  loading_types_ids: 'loading_types_ids',
  medical_book: 'medical_book',
  middlename: 'middlename',
  modular_cargo: 'modular_cargo',
  notes: 'notes',
  packages_id: 'packages_id',
  payment_rate_type_id: 'payment_rate_type_id',
  payment_rate_type: 'payment_rate_type',
  payment_type_id: 'payment_type_id',
  picture_url: 'picture_url',
  post_address: 'post_address',
  prefix: 'prefix',
  prepayment: 'prepayment',
  price: 'price',
  is_vat_included: 'is_vat_included',
  round_trip: 'round_trip',
  loading_address: 'loading_address',
  unloading_address: 'unloading_address',
  t1: 't1',
  time_period: 'time_period',
  round_clock1: "round_clock1",
  round_clock2: "round_clock2",
  tir: 'tir',
  transport_bodytype_ids: 'transport_bodytype_ids',
  loading_date_from: 'loading_date_from',
  loading_date_to: 'loading_date_to',
  loading_time_from: 'loading_time_from',
  loading_time_to: 'loading_time_to',
  unloading_date_from: 'unloading_date_from',
  unloading_date_to: 'unloading_date_to',
  unloading_time_from: 'unloading_time_from',
  unloading_time_to: 'unloading_time_to',
  loading_from: 'loading_from',
  loading_to: 'loading_to',
  unloading_from: 'unloading_from',
  unloading_to: 'unloading_to',
  unloading_types_ids: 'unloading_types_ids',
  upload: 'upload',
  user_id: 'user_id',
  transportation_type_id: 'transportation_type_id',
  volume: 'volume',
  weight: 'weight',
  width: 'width',
  route_distance_meters: 'route_distance_meters',
};

export const freightsFieldsArray = {
  additional_loading_address: '',
  additional_loading_addresses: [],
  additional_unloading_address: '',
  additional_unloading_addresses: [],
  adr_captions_ids: '',
  air_passage: false,
  bank_days: '',
  belts: '',
  car_count: '',
  cargo_designations_additional: '',
  cargo_designations_id: '',
  cmr: false,
  conics: false,
  count: '',
  currency_id: '',
  diameter: '',
  direct_contract: false,
  document: '',
  employee_ids: '',
  fuel_prepayment: false,
  gps_tracking: false,
  height: '',
  hitch: false,
  is_other: false,
  length: '',
  loading_types_ids: '',
  unloading_types_ids: '',
  logists: '',
  medical_book: false,
  modular_cargo: false,
  notes: '',
  packages_id: '',
  payment_rate_type_id: '',
  payment_type_id: '',
  picture: '',
  prepayment: '',
  price: '',
  is_vat_included: false,
  round_trip: false,
  loading_address: null,
  unloading_address: null,
  t1: false,
  tir: false,
  round_clock1: false,
  round_clock2: false,
  transport_bodytype_ids: [],
  loading_date_from: null,
  loading_date_to: null,
  loading_time_from: null,
  loading_time_to: null,
  unloading_date_from: null,
  unloading_date_to: null,
  unloading_time_from: null,
  unloading_time_to: null,
  loading_from: null,
  loading_to: null,
  unloading_from: null,
  unloading_to: null,
  upload: false,
  transportation_type_id: '',
  volume: '',
  weight: '',
  width: '',
  route_distance_meters: null,
};

class Cargo extends BaseMappingsModel {
  constructor(data) {
    for (let item in data) {
      if (data[item] === null) {
        data[item] = '';
      }
    }

    super(MAPPINGS, data);

    // If custom designation is provided, clear the selected ID
    if (this.cargo_designations_additional) {
      this.cargo_designations_id = '';
    }
  }

  static formData(data, isAuction = false) {
    const cargo = new Cargo(data);

    if (cargo.additional_loading_addresses) {
      cargo.additional_loading_addresses = cargo.additional_loading_addresses
        .filter(Boolean)
        .map((item) => (item.value ? item.value : item));
    } else {
      cargo.additional_loading_addresses = [];
      cargo.additional_loading_address = [];
    }
    if (cargo.additional_unloading_addresses) {
      cargo.additional_unloading_addresses = cargo.additional_unloading_addresses
        .filter(Boolean)
        .map((item) => (item.value ? item.value : item));
    } else {
      cargo.additional_unloading_addresses = [];
      cargo.additional_unloading_address = [];
    }

    if (cargo.employee_ids.length > 0) {
      cargo.employee_ids = cargo.employee_ids.map((item) => item.value);
    } else {
      cargo.employee_ids = [];
    }

    const loadingFrom = new Date(cargo.loading_date_from);
    const loadingTo = new Date(cargo.loading_date_to || cargo.loading_date_from);
    delete cargo.loading_date_from;
    delete cargo.loading_date_to;

    const unloadingFrom = new Date(cargo.unloading_date_from);
    const unloadingTo = new Date(cargo.unloading_date_to || cargo.unloading_date_from);
    delete cargo.unloading_date_from;
    delete cargo.unloading_date_to;

    const defaultStartTime = '00:00:00';
    const defaultEndTime = '23:59:59';
    const setTime = (date, time) => {
      if (!date || !time) {
        return;
      }

      const [hours, minutes, seconds] = time.split(':');

      if (hours) date.setHours(Number(hours));
      if (minutes) date.setMinutes(Number(minutes));
      if (seconds) date.setSeconds(Number(seconds));
    };

    setTime(loadingFrom, (cargo.round_clock1 ? defaultStartTime : (cargo.loading_time_from || defaultStartTime)));
    setTime(loadingTo, (cargo.round_clock1 ? defaultEndTime : (cargo.loading_time_to || defaultEndTime)));
    delete cargo.loading_time_from;
    delete cargo.loading_time_to;
    delete cargo.round_clock1;

    setTime(unloadingFrom, (cargo.round_clock2 ? defaultStartTime : (cargo.unloading_time_from || defaultStartTime)));
    setTime(unloadingTo, (cargo.round_clock2 ? defaultEndTime : (cargo.unloading_time_to || defaultEndTime)));
    delete cargo.unloading_time_from;
    delete cargo.unloading_time_to;
    delete cargo.round_clock2;

    cargo.loading_from = loadingFrom.toISOString();
    cargo.loading_to = loadingTo.toISOString();
    cargo.unloading_from = unloadingFrom.toISOString();
    cargo.unloading_to = unloadingTo.toISOString();

    for (let item in cargo) {
      if (cargo[item] === '' || cargo[item] === undefined) {
        cargo[item] = 'null';
      }

      if (freightsFieldsArray[item] === undefined || item === 'is_other') {
        delete cargo[item];
      }
    }

    if (cargo.loading_address !== undefined) {
      cargo.loading_address =
        cargo.loading_address && cargo.loading_address.value ? cargo.loading_address.value : cargo.loading_address;
      cargo.loading_address = cleanAddress(cargo.loading_address);
    }
    if (cargo.unloading_address !== undefined) {
      cargo.unloading_address =
        cargo.unloading_address && cargo.unloading_address.value
          ? cargo.unloading_address.value
          : cargo.unloading_address;
      cargo.unloading_address = cleanAddress(cargo.unloading_address);
    }

    // Clean additional addresses
    if (cargo.additional_loading_addresses) {
      cargo.additional_loading_addresses = cargo.additional_loading_addresses.map(cleanAddress);
    }
    if (cargo.additional_unloading_addresses) {
      cargo.additional_unloading_addresses = cargo.additional_unloading_addresses.map(cleanAddress);
    }

    if (isAuction) {
      cargo.expires = data.expires;
    }

    return cargo;
  }

  static initialValues() {
    return freightsFieldsArray;
  }
}

export default Cargo;
